// These constants are injected via webpack environment variables.
// You can add more variables in webpack.common.js or in profile specific webpack.<dev|prod>.js files.
// If you change the values in the webpack config files, you need to re run webpack to update the application

import { environment } from "src/environments/environment";

// export const VERSION = process.env.VERSION;
// export const DEBUG_INFO_ENABLED: boolean = !!process.env.DEBUG_INFO_ENABLED;
// export const SERVER_API_URL = process.env.SERVER_API_URL;
// export const BUILD_TIMESTAMP = process.env.BUILD_TIMESTAMP;

let env = environment

export const VERSION = '0.0.0';
export const DEBUG_INFO_ENABLED = false;


// export const SERVER_API_URL = 'https://qa.tdis-marine.com/';

export const SERVER_API_URL = '/marine/';


// export const GOOGLE_API_KEY = 'AIzaSyD6RrviKgFJL0AW_8HdOZJQWGaJOvx7Mpc';

// export const GOOGLE_CAPTCHA_API_KEY ='6LdsyAocAAAAABcjXHYabaXIU9F067QC4SYFb9fz';

// export const SERVER_API_URL = env.serverUrl;

export const GOOGLE_API_KEY = env.googleApiKey;

export const GOOGLE_CAPTCHA_API_KEY = env.googleCaptchaKey;

export const BUILD_TIMESTAMP = new Date().getTime();
